/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import {
  UPDATE_FILTERS,
  VisitsGlobalContext,
  blankFilters,
} from '@mummssoftware/global-context';
import { isEqual } from 'lodash-es';
import { makeStyles } from '@material-ui/core';
import { FilterWrapper } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';
import { DateFilter } from './DateFilter';
import { LateChartFilter } from './LateChartFilter';
import { LengthFilter } from './LengthFilter';
import { OfficeFilter } from './OfficeFilter';
import { AttributeFilter } from './AttributeFilter';

const commonRootProps = { height: '35px', width: '55px', padding: '3px' };
const inputProps = { input: { padding: '0 0 0 5px', fontSize: '.95rem' } };

export const SummaryFilterContext = React.createContext({
  tentativeFilters: null as any,
  updateTentFilters: null as any,
  getInputStyles: null as any,
  hasPendingFilters: false,
});

export const SummaryFiltersProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    fromDate,
    toDate,
    officeFilter,
    minDurationHH,
    minDurationMM,
    chartAfterDD,
    chartAfterHH,
    summaryAttributeIds,
    summaryAttributeMatchMode,
  } = useContext(VisitsGlobalContext);

  const filters = {
    fromDate,
    toDate,
    officeFilter,
    minDurationHH,
    minDurationMM,
    chartAfterDD,
    chartAfterHH,
    summaryAttributeIds,
    summaryAttributeMatchMode,
  };

  const [tentativeFilters, setTentFilters] = useState(filters);
  const noChange = isEqual(filters, tentativeFilters);

  const getInputStyles = (changed: boolean) =>
    makeStyles((theme) => ({
      root: {
        color:
          (changed && `${(theme as any).palette.text.secondary}`) ||
          `${(theme as any).palette.text.primary}`,
        ...commonRootProps,
      },
      ...inputProps,
    }))();

  return (
    <SummaryFilterContext.Provider
      value={{
        tentativeFilters,
        updateTentFilters: setTentFilters,
        getInputStyles,
        hasPendingFilters: !noChange,
      }}
    >
      {children}
    </SummaryFilterContext.Provider>
  );
};

export const SummaryFilters = () => {
  const {
    tentativeFilters,
    updateTentFilters: setTentFilters,
    hasPendingFilters,
  } = useContext(SummaryFilterContext);
  const { dispatchVG } = useContext(VisitsGlobalContext);

  const noChange = !hasPendingFilters;

  const syncFilters = () => {
    dispatchVG({ type: UPDATE_FILTERS, payload: tentativeFilters });
  };

  const clearFilters = () => {
    setTentFilters(blankFilters);
    dispatchVG({ type: UPDATE_FILTERS, payload: blankFilters });
  };

  return (
    <FilterWrapper className="visit-summary-attribute-filters">
      <DateFilter />
      <OfficeFilter />
      <AttributeFilter />
      <LengthFilter />
      <LateChartFilter />

      <Button
        variant="outlined"
        color="primary"
        size="small"
        disabled={noChange}
        onClick={syncFilters}
        style={{ alignSelf: 'end' }}
      >
        {defaults.submit}
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        disabled={noChange}
        onClick={clearFilters}
        style={{ alignSelf: 'end' }}
      >
        {defaults.clear}
      </Button>
    </FilterWrapper>
  );
};
